module.exports = __webpack_public_path__ + "static/media/m (7).0c554165.jpg";